import { Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = ({ business, logo }) => {
  return (
    <footer className="relative border-t border-white/10 bg-ad-black px-5 sm:px-8 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 pb-12">
          <div>
            <img src={logo} alt={business.name} className="h-16 w-auto object-contain mb-4" />
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              {business.name} {business.name_accent}. {business.tagline}.
            </p>
          </div>

          <div>
            <h4 className="font-display text-xl uppercase tracking-wide mb-5 metallic-text">Contact</h4>
            <div className="flex flex-col gap-3 text-white/70 text-sm">
              <a
                href={`https://www.google.com/maps?q=${encodeURIComponent(business.address)}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-2 hover:text-ad-red transition-colors"
              >
                <MapPin size={16} className="mt-0.5 shrink-0 text-ad-red" />
                {business.address}
              </a>
              {business.phones?.map((p) => (
                <a key={p} href={`tel:${p.replace(/[^0-9]/g, "")}`} className="flex items-center gap-2 hover:text-ad-red transition-colors">
                  <Phone size={16} className="text-ad-red" /> {p}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-xl uppercase tracking-wide mb-5 metallic-text">Hours</h4>
            <div className="flex flex-col gap-2 text-white/70 text-sm">
              {business.hours?.map((h) => (
                <div key={h.day} className="flex justify-between gap-3 max-w-[260px]">
                  <span className="text-white/45">{h.day}</span>
                  <span>{h.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40 uppercase tracking-widest">
          <span>© {new Date().getFullYear()} {business.name} {business.name_accent}. All Rights Reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-ad-red transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
